export const APPEND_DAMAGE_LIST = "DAMAGE_LIST_APPEND_DAMAGE_LIST";
export const SET_DAMAGE_CANLOADMORE = "DAMAGE_LIST_SET_DAMAGE_CANLOADMORE";
export const SET_DAMAGE_LIST = "DAMAGE_LIST_SET_DAMAGE_LIST";
export const SET_FETCHING = "DAMAGE_LIST_SET_FETCHING";
export const SET_FILTER = "DAMAGE_LIST_SET_FILTER";
export const SET_SORTING = "DAMAGE_LIST_SET_SORTING";
export const SET_ERROR = "DAMAGE_LIST_SET_ERROR";
